import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";
import { FailState } from "../../models/fail-state";
import { OrderProposalState } from "../../models/order-proposal/order-proposal-state";
import { AppState } from "../../reducers";
import { OrderProposalSelectors } from "../../selectors/order-proposal.selectors";

@Injectable()
export class OrderProposalsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.orderProposals.get),
			withLatestFrom(this.store.select(OrderProposalSelectors.orderProposals)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(OrderProposalActions.orderProposals.getSuccess(state))
					: of(OrderProposalActions.orderProposals.getApi({ orderId: action.orderId }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.orderProposals.getApi),
			switchMap((action) =>
				this.orderProposalService.orderProposals(action.orderId).pipe(
					map((proposals) =>
						OrderProposalActions.orderProposals.getSuccess({
							orderProposals: { [action.orderId]: proposals },
							loading: false
						})
					),
					catchError((error) =>
						of(OrderProposalActions.orderProposals.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(action, state: OrderProposalState): boolean {
		return (
			!_.has(state, "error") &&
			!state.loading &&
			_.has(_.get(state, "orderProposals", {}), action.orderId)
		);
	}
}
